module.exports = __webpack_public_path__ + "img/ic_tiktok_select@2x.1d13c54.png";